const LARGE = 1024;

const toggleAccordions = () => {
  $( '.all-videos-page.mobile' ).each( function() {
    let tab = $( this );
    let name = tab.find( '.tab-content__inner' );

    name.on( 'click', function() {

      if ( window.innerWidth >= LARGE ) {
        return;
      }

      name.parent().toggleClass( 'active' );
      name.next().slideToggle();
    });
  });

};


$( document ).ready( function() {
  toggleAccordions();
});

